import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-ipt-panel',
  templateUrl: './ipt-panel.component.html',
  styleUrls: ['./ipt-panel.component.scss']
})
export class IptPanelComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<any>();

  lastAction: string;

  data = [
    {id:0, label: 'Lunes', checked: false },
    {id:1, label: 'Martes', checked: false },
    {id:2, label: 'Miércoles', checked: false },
    {id:3, label: 'Jueves', checked: false },
    {id:4, label: 'Viernes', checked: false },
    {id:5, label: 'Sábado', checked: false },
    {id:6, label: 'Domingo', checked: false },
    {id:7, label: 'Todos', checked: false },
    ];

  constructor() { }

  ngOnInit() {
    this.messageEvent.emit(this.data)
  }


  onChange(event, index, item) {

    item.checked = !item.checked;
    if(item.checked === true){
      this.data.forEach(x=>{
        if(x.id === item.id && item.checked){
          x.checked = true;
        }
      })
    }

    //* SELECCIONAR TODOS LOS DIAS CUANDO EL ID ES 7, CORRESPONDIENTE A  */
    if(item.checked === true && item.id === 7){
      this.data.forEach(x=>x.checked = true)
    }

    if(item.checked === false && item.id === 7){
      this.data.forEach(x=>x.checked = false)
    }

    this.messageEvent.emit(this.data)


}

}
